<template>
  <a-card :bordered="false">
    <a-table rowKey="id" :columns="getColumns()" :pagination='false' :data-source="templateList">
      <span slot="action" slot-scope="text, record">
        <a @click='preViewContractEvent(record)'>预览</a>
        <a-divider type="vertical"/>
        <a @click='consultContractEvent(record)'>协商约定</a>
      </span>
    </a-table>
    <a-modal
      :title="ruleForm.templateTypeStr"
      :width="600"
      :visible="modalVisible"
      @cancel="cancelEvent"
      :confirmLoading="submitLoading"
      @ok="submitEvent"
    >
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="双方协商约定" prop="negotiationAgreement">
          <a-textarea v-model="ruleForm.negotiationAgreement" placeholder="填写其他双方协商约定事宜" :maxLength="5000"
                      :autosize="{ minRows: 4, maxRows: 20 }"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'ElectronicContractConfigure',
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      templateList: [],
      modalVisible: false,
      submitLoading: false,
      ruleForm: {},
      rules: {
        negotiationAgreement: [{ required: true, message: '填写其他双方协商约定事宜', trigger: 'blur' }]
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 17 }
    }
  },
  created() {
    this.getTemplateList()
  },
  methods: {
    getTemplateList() {
      this.getHttpServices().getServerApiService().post('tourist/contract/getTemplateList', this.queryParams).then(res => {
        this.templateList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '模板名称',
          dataIndex: 'templateTypeStr'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    preViewContractEvent(record) { // 预览
      window.open(record.templateUrl)
    },
    consultContractEvent(record) { // 协商约定
      this.ruleForm = JSON.parse(JSON.stringify(record))
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    cancelEvent() {
      this.modalVisible = false
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getServerApiService().post('tourist/contract//saveTemplate', {
          id: this.ruleForm.id,
          merchantId: this.ruleForm.merchantId,
          negotiationAgreement: this.ruleForm.negotiationAgreement,
          platformId: this.ruleForm.platformId
        }).then(() => {
          this.$message.success('保存成功')
          this.getTemplateList()
          this.cancelEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
